<div class="body ui container" fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="space-between center" class="top">
    <div>
      <span>Home</span>
      <h2 class="ui primary header">Awarded Projects</h2>
    </div>
  </div>
  <div class="ui divider" appMargin marginY="3"></div>

  <div class="ui segment" style="border-radius: 4px" appMargin marginT="0">
    <app-search-filter
      [filter]="filter"
      (onSearch)="searchRecords($event)"
      (onDisplayRows)="displayRecords($event)"
      (onSort)="sortRecords($event)"
    ></app-search-filter>
  </div>

  <div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
    <app-applicant-award-row
      [project]="s"
      *ngFor="let s of projects"
      (onView)="viewProject($event)"
    ></app-applicant-award-row>

    <div class="ui vertical basic segment">
      <div class="ui two column grid">
        <div class="column middle aligned">
          <div class="ui icon small button">
            <i class="database icon"></i>
          </div>
          <a class="ui basic label">{{ totalItems }} Record(s)</a>
        </div>
        <div
          class="column right aligned pagination menu"
          style="margin-left: auto"
        >
          <sui-pagination
            class="small"
            [collectionSize]="totalItems"
            [pageSize]="rows"
            [maxSize]="maxSize"
            [hasEllipses]="false"
            [page]="currentPage"
            (pageChange)="nextPage($event)"
          >
          </sui-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
